import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// Components
export * from "./lib/KButton";
export * from "./lib/KNavbar";
export * from "./lib/KCard";
export * from "./lib/KNavBrand";
export * from "./lib/KNavDropdown";
export * from "./lib/KCheck";
export * from "./lib/KInput";
export * from "./lib/KNavLangSelector";
export * from "./lib/KNavLink";
export * from "./lib/KSelect";
export * from "./lib/KStepProgress";
export * from "./lib/locale";
export * from "./lib/KAccordion";
export * from "./lib/KForm";
export * from "./lib/KLabel";
export * from "./lib/KFooter";
export * from "./lib/KStandardFooter";
export * from "./lib/KModal";
export * from "./lib/KSpinner";
export * from "./lib/Boxes";
export * from "./lib/alert/actions";
export * from "./lib/alert/reducer";
export * from "./lib/alert/KAlert";
export * from "./lib/alert/KAlertContainer";
export * from "./lib/alert/KAlertProvider";
export * from "./lib/alert/KAlertTemplate";
export * from "./lib/alert/types";
export * from "./lib/KContainer";
export * from "./lib/KApp";
export * from "./lib/KSpace";
export * from "./lib/KErrorPage";
export * from "./lib/kptable";
export * from "./lib/KColSeparator";
export * from "./lib/KToggleButton";
export * from "./lib/KSearchbar";
export * from "./lib/KUserProfile";
export * from "./lib/KNavBrandFixed";
export * from "./lib/KTableLoader";
export * from "./lib/KDate";
export * from "./lib/KFileUpload";
export * from "./lib/commons";
export * from "./lib/kpcursedtable";
export * from "./lib/KGlobalSpinner";
export * from "./lib/KSidebar";
export * from "./lib/KSortableList";
export * from "./lib/KList";
// Styles (scss, css)
import "./css/mainUIStyle.scss";
import "./fonts/fontawesome-pro/scss/fontawesome.scss";
import "./fonts/fontawesome-pro/scss/light.scss";
import "./fonts/fontawesome-pro/scss/regular.scss";
import "./fonts/fontawesome-pro/scss/solid.scss";
import "./fonts/fontawesome-pro/scss/duotone.scss";
import "./fonts/fontawesome-pro/scss/brands.scss";
import "./fonts/fontawesome-pro/scss/thin.scss";
import "./fonts/fontawesome-pro/scss/sharp-light.scss";
import "./fonts/fontawesome-pro/scss/sharp-solid.scss";
import "./fonts/fontawesome-pro/scss/sharp-thin.scss";
import "./fonts/fontawesome-pro/scss/sharp-regular.scss";
import "./fonts/starwars-glyphicons/css/starwars-glyphicons.css";
// SVGs
export * from "./images";
// Types and functions
export function noop() {
    return;
}
export function tooltipate(element, tooltip, placement = "top", useIcon = false, showDelay) {
    return tooltip ? (useIcon ? (_jsxs(_Fragment, { children: [element, _jsx(OverlayTrigger, { placement: placement, overlay: _jsx(Tooltip, { id: `tooltip-${Math.random()}`, children: tooltip }), children: _jsx("i", { className: "fal fa-info-circle tooltip-icon text-secondary" }) }, Math.random())] })) : (_jsx(OverlayTrigger, { placement: placement, overlay: _jsx(Tooltip, { id: `tooltip-${Math.random()}`, children: tooltip }), children: element }, Math.random()))) : (element);
}
export const delay = async (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export async function fileToUint8Array(file) {
    const buff = await file.arrayBuffer();
    return new Uint8Array(buff);
}
export function utf8ToB64(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    }));
}
export function b64ToUtf8(b64) {
    return decodeURIComponent(Array.prototype.map
        .call(atob(b64), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
}
export function b64ToUint8Array(b64) {
    return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}
export function arrayBufferToB64(arrayBuffer) {
    let base64 = "";
    const encodings = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    const bytes = new Uint8Array(arrayBuffer);
    const byteLength = bytes.byteLength;
    const byteRemainder = byteLength % 3;
    const mainLength = byteLength - byteRemainder;
    let a, b, c, d;
    let chunk;
    // Main loop deals with bytes in chunks of 3
    for (let i = 0; i < mainLength; i = i + 3) {
        // Combine the three bytes into a single integer
        chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        // Use bitmasks to extract 6-bit segments from the triplet
        a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
        b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
        c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
        d = chunk & 63; // 63       = 2^6 - 1
        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }
    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
        chunk = bytes[mainLength];
        a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2
        // Set the 4 least significant bits to zero
        b = (chunk & 3) << 4; // 3   = 2^2 - 1
        base64 += encodings[a] + encodings[b] + "==";
    }
    else if (byteRemainder == 2) {
        chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];
        a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
        b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4
        // Set the 2 least significant bits to zero
        c = (chunk & 15) << 2; // 15    = 2^4 - 1
        base64 += encodings[a] + encodings[b] + encodings[c] + "=";
    }
    return base64;
}
